











































































import Vue from 'vue'
import c from '@/config/const'

export default Vue.extend({
  data() {
    return {
      users: [],
      factories: [],
      curFactoryId: null,
      bindingFactoryDialogVisible: false,
      addUserDialogVisible: false,
      curUserId: null,
      addUserForm: {
        username: '',
        password: 'Abcd1234',
      },
    }
  },
  mounted() {
    this.fetchAllUsers()
    this.fetchAllFactories()
  },
  methods: {
    fetchAllUsers() {
      this.$http
        .get('/mes/user', {
          params: {
            limit: c.LIMIT_MAX,
          },
        })
        .then(({ data }) => {
          this.users = data.totalCount > 0 ? data.users : []
        })
    },
    fetchAllFactories() {
      this.$http
        .get('/mes/factory', {
          params: {
            limit: c.LIMIT_MAX,
          },
        })
        .then(({ data }) => {
          this.factories = data.totalCount > 0 ? data.factories : []
        })
    },
    addFactoryAdmin() {
      const userId = this.curUserId
      const factoryId = this.curFactoryId
      if (userId !== null && factoryId !== null) {
        this.$http
          .put(`/mes/factory/${factoryId}/admin/${userId}`)
          .then(({ data }) => {
            this.$notify({
              title: '添加成功',
              message: `为用户添加工厂成功`,
              type: 'success',
            })
          })
          .catch(() => {
            this.$notify({
              title: '添加失败',
              message: '为用户添加工厂失败',
              type: 'error',
            })
          })
          .finally(() => {
            this.bindingFactoryDialogVisible = false
          })
      }
    },
    cancelAddUser() {
      this.addUserDialogVisible = false
      this.resetAddUserForm()
    },
    resetAddUserForm() {
      this.addUserForm = {
        username: '',
        password: 'Abcd1234',
      }
    },
    addUser() {
      this.$http
        .post('/mes/user', {
          password: this.addUserForm.password,
          username: this.addUserForm.username,
        })
        .then(({ data }) => {
          this.$notify({
            title: '添加成功',
            message: `添加用户 ${data.username} 成功`,
            type: 'success',
          })
          this.fetchAllUsers()
        })
        .catch(() => {
          this.$notify({
            title: '添加失败',
            message: '添加用户失败',
            type: 'error',
          })
        })
        .finally(() => {
          this.addUserDialogVisible = false
        })
    },
  },
})
